// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Agents'" tab="true"></sub-header>

  <div class="info">
    <div class="info__column">
      <div class="info__field">
        <span class="info__field-label">Branch name:</span>
        <span class="info__field-value">{{\$ctrl.branch.name}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Branch code:</span>
        <span class="info__field-value">{{\$ctrl.branch.code}}</span>
      </div>
    </div>
  </div>
  <table class="users-list-table table table--last-column-to-right" at-table at-list="\$ctrl.agents">
    <thead>
    <tr>
      <th at-attribute="no">No</th>
      <th at-attribute="code">Code</th>
      <th at-attribute="status">Status</th>
      <th at-attribute="username">Username</th>
      <th at-attribute="effectiveName">Full name</th>
      <th at-attribute="actions">Actions</th>
    </tr>
    </thead>
    <tbody class="tbody">
    <tr>
      <td at-attribute="no" class="users-list__number-column">{{\$index+1+'.'}}</td>
      <td at-implicit at-attribute="code"></td>
      <td at-implicit at-attribute="status">
        {{item.enabled ? 'Active' : 'Inactive'}}
      </td>
      <td at-implicit at-attribute="username"></td>
      <td at-implicit at-attribute="effectiveName"></td>
      <td at-attribute="actions" class="users-list__open-link-column table__actions">
        <button type="button"
                class="btn btn-info"
                ng-click="\$ctrl.openCIF(item)">
          CIF
        </button>
      </td>
      <td class="users-list__open-link-column">
        <button class="btn btn-warning open-link"
                ng-if="item.enabled"
                command-access="UpdateAgent"
                ng-click="\$ctrl.edit(item)">
          Edit
        </button>
      </td>
      <td class="users-list__open-link-column">
        <button ng-if="item.enabled"
                command-access="DeactivateAgent"
                class="btn btn-danger"
                ng-click="\$ctrl.deactivate(item)">
          Deactivate
        </button>
      </td>
      <td class="users-list__open-link-column">
        <button ng-if="!item.enabled"
                command-access="ActivateAgent"
                class="btn btn-warning"
                ng-click="\$ctrl.activate(item)">
          Activate
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/list/agents-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;